
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/[tickerSymbol]/events",
      function () {
        return require("private-next-pages/us/[tickerSymbol]/events.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/[tickerSymbol]/events"])
      });
    }
  